
import gql from 'graphql-tag';
import userFavProductPersonalAccident from '~/apollo/queries/user/userFavProductPersonalAccident'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import paTooltips from '~/apollo/queries/product/tooltips/personalAccidentTooltips';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: 'FavProductPersonalAccident',
  mixins: [productPromotionMixins, productInsuranceNameMixins],
  props: {
    productId: {
      type: String,
      default: '',
    },
    params: {
      type: String,
      default: ''
    },
    favProductId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    product: Object,
    productLoading: 0,
    currentLink: "",
  }),
  apollo: {
    product: {
      loadingKey: "productLoading",
      query: gql`
        ${userFavProductPersonalAccident}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);

        // console.debug(returnObj);

        return returnObj;
      },
      update(data) {
        return data?.paScenarios?.data;
      },
      result({ data }) {
        // console.debug(JSON.stringify(data));
      },
    },
    tooltips: {
      query: paTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).PersonalAccident;
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading) {
        if (this.product) {
          return this.product.map((item) => {
            // console.log("#######ITEM#######")
            // console.log("plans");
            // console.log(item.attributes.pa_plans.data);
            // console.log(item.attributes.product_promotions.data);
            // const decoderCTALink = '';
            let promotionPrices = Array;
          promotionPrices = [];

          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          let decoderCTALink = '';
          let decoderCTAText = '';
          let hide = Boolean;
          hide = false;
          let noPopup = Boolean;
          noPopup = false;
          let mainCTA = this.getDecoderCTA(item, decoderCTALink);

          // check scenario level promo first , then plan level promotion 
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.pa_plans.data[0].attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.pa_plans.data[0].attributes.product_promotions.data;
          }
          
          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (!promotion) {
              promotion = null;
            } else {
              if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink =
                    promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                  decoderCTAText = this.$t('products.product_website');

                  mainCTA = this.getDecoderCTA(item, decoderCTALink)
              }
              const discounts = promotion.attributes.DiscountPercentage;
              if (discounts) {
                // calculate promotion price for annual premium
                // console.log('######IN DISCOUNT#######');
                const annualPremium = item.attributes.pa_premiums.data[0].attributes.annual_premium;

                if (discounts.Year1 === 0) {
                  promotionPrices[0] = null;
                } else {
                  const calculatedPrice = (annualPremium * (100 - discounts.Year1)) / 100;
                  promotionPrices[0] = parseInt(calculatedPrice.toFixed(0));
                }
              }

              const translation = promotion.attributes.product_promotion_translations?.data[0];
              hide = translation?.attributes?.HideBanner;
              noPopup = translation?.attributes?.NoPopup??false;
            }
          }

          const filteredTranslations = this.getFilteredTranslations(item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);

          return {
            scenario_code: item.attributes.scenario_code,
            plan_code: item.attributes.plan_code,
            annual_premium: item.attributes.pa_premiums.data[0].attributes.annual_premium,
            overall_score: item.attributes.overall_score,
            death_dismemberment_score: item.attributes.death_dismemberment_score,
            medical_score: item.attributes.medical_score,
            physio_score: item.attributes.physio_score,
            bonesetter_score: item.attributes.bonesetter_score,
            sum_assured: item.attributes.sum_assured,
            overall_star: item.attributes?.overall_star,
            is_flexible_sa: item.attributes.pa_plans.data[0].attributes.flexible_sa,
            show_cta: item.attributes.show_cta,

            // plan
            plan_name: item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes.name,

            // product_website:
            //   item.attributes.home_plan.data.attributes.home_plan_translations.data[0].attributes.product_website,

            // insurer
            insurer_name_first:
              item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes.logo,
            insurer_code:
              item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes.code,

            product_promotion: promotion,
            promotion_prices: promotionPrices,
            promotion_last_call: promotion_last_call,

            // discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
            // cta_button_link: CTAButtonLink,
            // cta_button_text: CTAButtonText,

            main_cta: mainCTA,

            scenarioID: item.id,
            hide,
            noPopup,
          };
          })[0];
        }
      }
      return null;
    },

    displayProduct() {
      const item = this.simpleItem;
      console.dir(item);
      if (item) {
        const featureArray = [
          {
            text: '$' + this.$formatPrice(parseInt(item.sum_assured)) + ' ' + this.$t('products.personal_accident.pd_sum_assured'),
            type: 'sum_assured'
          },
          {
            text: this.$t('products.personal_accident.pd_flexible_sa'),
            type: 'optional_sum_assured'
          }
        ];
        return {
          favProductId: this.favProductId,
          id: item.scenario_code,
          category: this.category,
          scenarioId: item.scenarioID,
          showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
          showTrending: false,
          showCTA: item.show_cta,

          productLink: this.$extendPath(
            '/products/personal-accident',
            '/' + item.scenario_code
          ),
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo?.data?.attributes.url,
            logoAlt: item.insurer_name_first,
          },
          userRating: {
            score: item.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: item.overall_score,
            description: this.$t('products.personal_accident.pd_overall_score'),
            toolTipHtml: this.getTooltipContentByKey('pa_overallScore'),
            // toolTipHtml: this.getOverallScoreTooltip(),
          },
          features: featureArray,
          keyItems: [
            {
              value: this.$formatScore(item.death_dismemberment_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_death_dismember_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_deathDismembermentScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(item.medical_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_medical_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_medicalScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(item.physio_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_physio_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_physioScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(item.bonesetter_score) + ' / 10',
              key: this.$t('products.personal_accident.pd_chinese_med'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('pa_bonesetterScore'),
              symbolValue: '',
              originalValue: '',
            },
          ],
          compactKeyItems: [
            {
              value: item.promotion_prices[0]
                ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
                : this.$formatPrice(item.annual_premium),
              key: this.$t('products.personal_accident.pd_firstYearPremium'),
              topSubText: 'HKD',
              toolTipHtml: this.getTooltipContentByKey('pa_adult'),
              symbolValue: '',
              originalValue: '',
            },
          ],
          promotion: {
            category:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: item.product_promotion?.id,
            scenarioId: item.scenarioID,
            hide: item.hide,
            noPopup: item.noPopup,
            lastCall: item.promotion_last_call
          },

          mainButtonCTA: item.main_cta,

          price: {
            originalPrice: item.promotion_prices[0] ? this.$formatPrice(item.annual_premium) : '',
            discountPrice: item.promotion_prices[0]
              ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
              : this.$formatPrice(item.annual_premium),
            prefix: 'HKD',
            postfix: '',
            subText: this.$t('products.personal_accident.pd_firstYearPremium'),
            toolTipHtml: this.getTooltipContentByKey('pa_adult'),
          },
        }
      }
      return null;
    },

    simpleParams() {
      let vars = Array;
      vars = [];
      const hash = this.params.split('&');

      for (let i = 0; i < hash.length; i++) {
        const params = hash[i].split("=");
        vars[params[0]] = params[1];
      }

      return vars;
    }
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'PersonalAccident');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {
    getTooltipContentByKey(mKey) {
      return this.tooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    unfavourite() {
      this.$emit("unfavourite", this.favProductId)
    },
    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.pa_plans.data[0].attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const link = this.currentLink;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.personal_accident.pd_categoryName'), insurer, planName, { link: link });
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.pa_plans.data.attributes?.saleable;
      const productWebsite =
        item.attributes.pa_plans.data[0].attributes.pa_plan_translations.data[0].attributes?.product_website;

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },
  },
};
